/**
 * Shared chart constants and utilities.
 * Centralizes color palettes used across dashboard charts and legend.
 * Uses CSS variables so colors respect ThemeProvider and dark mode.
 */

export const CHART_COLORS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
  'hsl(var(--chart-6))',
  'hsl(var(--chart-7))',
  'hsl(var(--chart-8))',
] as const;
